var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBmw = function SvgBmw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 271 274",
    style: {
      enableBackground: "new 0 0 271 274"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M135.5,17.5C69.5,17.5,16,71,16,137s53.5,119.5,119.5,119.5S255,203,255,137 S201.5,17.5,135.5,17.5L135.5,17.5z M247.2,137c0,61.7-50,111.7-111.7,111.7S23.8,198.7,23.8,137s50-111.7,111.7-111.7 S247.2,75.3,247.2,137z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(7.304985, 3.108504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "W_60_",
    className: "st1",
    d: "M186.1,83.2c1.6,1.7,4,4.6,5.3,6.3l24.2-15.4c-1.2-1.6-3.1-4-4.6-5.7l-15.3,10.1l-1,0.9 l0.8-1.1l6.8-13.5l-4.8-4.8l-13.5,6.8l-1.1,0.8l0.9-1l10.1-15.3c-1.8-1.5-3.5-2.9-5.7-4.6l-15.4,24.2c1.9,1.5,4.5,3.7,6.1,5.2 l14.5-7.5l0.9-0.7l-0.7,0.9L186.1,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M_60_",
    className: "st1",
    d: "M131.2,52.6l6.6-14.8l0.4-1.3l-0.1,1.4l0.7,19.8c2.3,0.2,4.7,0.5,7.1,0.9l-1.1-29.3 c-3.3-0.4-6.6-0.6-9.9-0.8l-6.5,16.2l-0.2,1.2l-0.2-1.2l-6.5-16.2c-3.3,0.1-6.6,0.4-9.9,0.8l-1.1,29.3c2.4-0.4,4.8-0.7,7.1-0.9 l0.7-19.8l-0.1-1.4l0.4,1.3l6.6,14.8H131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "B_x5F_22d_60_",
    className: "st1",
    d: "M77.7,75.9c3.8-4,6-8.7,2.2-13.1c-2.1-2.4-5.6-2.9-8.5-1.7l-0.3,0.1l0.1-0.3 c0.4-1.1,0.7-4.8-2.4-7.3c-1.5-1.2-3.4-1.7-5.3-1.5c-3.6,0.4-6.3,2.8-13.9,11.2c-2.3,2.5-5.6,6.5-7.6,9.1L62.7,92 C69.6,84.4,72.3,81.6,77.7,75.9z M50.8,71.1c4.2-5.1,8.6-9.7,10.6-11.5c0.6-0.6,1.3-1.2,2.2-1.4c1.4-0.4,2.8,0.6,3.1,2 c0.3,1.4-0.6,2.7-1.5,3.8C62.9,66.5,54.8,75,54.8,75L50.8,71.1z M58.9,78.8c0,0,7.9-8.3,10.4-11c1-1.1,1.7-1.7,2.4-2 c0.9-0.4,1.9-0.5,2.8,0.1c0.9,0.6,1.3,1.6,1.1,2.6c-0.3,1.2-1.2,2.3-2,3.2c-1.1,1.2-10.4,11.1-10.4,11.1L58.9,78.8z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.5,66.2V137H64.7C64.7,97.8,96.3,66.2,135.5,66.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M206.3,137c0,39.2-31.7,70.8-70.8,70.8V137H206.3z"
  })));
};
export default SvgBmw;